import styled, { css } from 'styled-components'
import type { AlertType } from '@store/alert'
import { BaseButton } from '../base'

interface AlertProps {
  $show: boolean
  $type?: AlertType
}

export const StyledAlert = styled.div<AlertProps>(
  ({ theme, $type = 'error', $show }) => css`
    width: min(calc(100% - 40px), 384px);
    height: auto;
    min-height: 50px;
    padding: 12px;
    border-radius: 16px;
    background-color: ${$type === 'success' ? '#DCFCE7' : '#FEE2E2'};
    box-shadow: ${$type === 'success'
      ? '0 0 24px rgba(0, 0, 0, 0.10)'
      : '0 2px 14px rgba(0, 0, 0, 0.15)'};
    display: flex;
    align-items: baseline;
    ${$type === 'success' && 'justify-content: center'};
    gap: 8px;
    position: fixed;
    left: 50%;
    top: 16px;
    transform: translateX(-50%);
    color: ${theme.colors[$type]};
    z-index: 100000;
    ${$show
      ? css`
          opacity: 1;
          visibility: visible;
        `
      : css`
          opacity: 0;
          visibility: hidden;
        `};
    transition: ${$show ? 150 : 0}ms ease-in;

    svg {
      height: 26px;
    }
  `,
)

export const MessageBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-self: center;
  font-weight: 590;
  font-size: 14px;
`

export const CloseAlert = styled(BaseButton)`
  content: '×';
  display: block;
  width: 24px;
  height: 24px;
  background-color: transparent;
  position: absolute;
  top: 50%;
  inset-inline-end: 16px;
  margin-top: -12px;
  font-size: 24px;
  line-height: 1;
  color: inherit;
  text-align: center;
`
